import { Component, OnInit } from '@angular/core';
import { IEpSearchBoxModel, EpButtonStyle, EpButtonSize, IEpTextBoxModel } from '@epicor/kinetic';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { FieldAgentClient, GetCustomerAddressHeadersRequest, Address } from 'ep-bt-field-agent-proxy';
import { PagingParameters, SortParameters, SortParametersDirection, SearchParameters } from 'ep-bt-field-agent-proxy';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { CompetitorPricing } from '../../models/competitor-pricing.model';
import { PageNames } from 'ep-bt-controls';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-competitor-pricing',
  templateUrl: './epbt-fa-competitor-pricing.component.html',
  styleUrls: ['./epbt-fa-competitor-pricing.component.scss']
})

export class EpbtFaCompetitorPricingComponent implements OnInit {

  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  public competitorPricingForm: FormGroup;
  searchParams: any;
  searchString: string;
  selectedBranchId: number;
  webTrackUser: any;
  public _searchString: string;
  competitorAddressRequest: GetCustomerAddressHeadersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  public pageSize = 10;
  competitorAddress: any;
  customerId: number;
  competitorModles: any[] = [];
  addressDropdown = false;
  addressCodeDropdown = false;
  addressid: any;
  selectCompetitorType: any;
  submitted = false;
  competitorPricing: any;
  datares: any;
  selectedCompetitorItem: any;
  errorCustomer: string;
  selectedAddressId: number;
  customerAddress: Address[] = [];
  //  testingAddressIndex:number=2932;

  customerTextBoxModel: IEpTextBoxModel = {
    id: 'customerTextBoxModel',
    autoFocus: true
  };

  constructor(
    private formBuilder: FormBuilder,
    public epbtFaCompetitorService: EpbtFaCompetitorService,
    private router: Router,
    private fieldAgentService: EpbtFieldAgentService,
    private client: FieldAgentClient,
    private customerService: EpbtFaCustomerService, ) { }

  // model: IEpSearchBoxModel = {
  //   debounceTime: 200,
  //   placeholder: 'Competitors..',
  //   title: '',
  //   onChange: (str: string) => {
  //     this._searchString = str.trim();
  //     this.epbtFaCompetitorService.searchCompetitorString = this._searchString;
  //   }
  // };


  ngOnInit() {

    // console.log(this.epbtFaCompetitorService.competitorPricing.customer, 'seleted customer details');
    this.competitorPricingForm = this.formBuilder.group({///
      competitor: [''],
    });

    if (!this.epbtFaCompetitorService.competitorPricing) {
      this.epbtFaCompetitorService.competitorPricing = new CompetitorPricing();
    }


    // Set Serch box vlaue
    if (this.epbtFaCompetitorService.competitorPricing.customer) {
      // this.epbtFaCompetitorService.competitorPricing.customer = this.epbtFaCompetitorService.selectedCustomer;
      // this.epbtFaCompetitorService.competitorPricing.CompetitorID =
      // this.model.searchValue = this.epbtFaCompetitorService.competitorPricing.customer.name;

      // Set Serch box vlaue

      this.competitorPricingForm.patchValue({///
        competitor: this.epbtFaCompetitorService.competitorPricing.customer.name
      });


      this.epbtFaCompetitorService.searchCompetitorString = this.epbtFaCompetitorService.competitorPricing.customer.name;
      this.selectedCompetitor();
    }

    // this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
    //   //this.pageSize = bistrackSettings.searchPageSize;
    // });

    // this.webTrackUser = this.fieldAgentService.getWebTrackUser(); && this.epbtFaCompetitorService.selectedCustomer.length > 0



    this.epbtFaCompetitorService.competitorPriceFormFlag = this.competitorPricingForm.valid;
  }

  onSearchClick(event: any) {
    this.errorCustomer = '';
    const charCode = event == null ? null : (event.which) ? event.which : event.keyCode;
    if (charCode == null || charCode == 13) {
      this.epbtFaCompetitorService.isCompetitor = true;
      // this.epbtFaCompetitorService.searchCompetitorString = '';
      this.epbtFaCompetitorService.searchCompetitorString = charCode == null ? this.competitorPricingForm.controls['competitor'].value : event.target.value;
      this.competitorPricingForm.patchValue({///
        competitor: this.epbtFaCompetitorService.searchCompetitorString
      });
      this.customerService.fromPage = PageNames.CompetitorPriceProductSearch;
      this.searchString = this.epbtFaCompetitorService.searchCompetitorString;
      if (this.searchString) {
        this.customerService.getCustomers(this.searchString, 1, (customers: any) => {
          if (customers && customers.length == 1) {
            this.epbtFaCompetitorService.competitorPricing.customer = customers[0];
            this.competitorPricingForm.patchValue({///
              competitor: this.epbtFaCompetitorService.competitorPricing.customer.name
            });
            this.selectedCompetitor();
          } else {
            this.router.navigate(['/home/customer']);
          }
        });
      } else {
        this.router.navigate(['/home/customer']);
      }
    }
  }

  // onSearchButtonClick(type: string) {
  //   this.epbtFaCompetitorService.isCompetitor = true;
  //   this.epbtFaCompetitorService.searchCompetitorString = '';
  //   this.epbtFaCompetitorService.searchCompetitorString = this.competitorPricingForm.controls['competitor'].value ?
  //     this.competitorPricingForm.controls['competitor'].value : this.epbtFaCompetitorService.searchCompetitorString;
  //   this.customerService.fromPage = PageNames.CompetitorPriceProductSearch;
  //   if (type == 'search') {
  //     this.router.navigate(['/home/customer']);
  //   }
  // }

  // selected customer start
  selectedCompetitor() {
    if (this.epbtFaCompetitorService.competitorPricing.customer) {
      this.customerId = this.epbtFaCompetitorService.competitorPricing.customer.customerId;
      this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
        this.webTrackUser = webTrackUser;
        this.addressropdown();
      });
    }
  }
  // api call start

  addressropdown() {
    this.competitorModles = [];
    this.competitorAddressRequest = new GetCustomerAddressHeadersRequest();
    // In BisTrack Cloud, we do not limit to WebTrack-only customers.
    this.competitorAddressRequest.currentUser = this.webTrackUser;
    this.competitorAddressRequest.currentUser.customer.customerId = this.customerId;

    this.paging = new PagingParameters();
    this.paging.index = 0;
    this.paging.count = this.pageSize;
    this.competitorAddressRequest.paging = this.paging;

    this.sort = new SortParameters();
    this.sort.sortColumn = 'AddressCode';
    this.sort.direction = SortParametersDirection.Ascending;
    this.competitorAddressRequest.sorting = this.sort;

    const customerAddressSearchParameter = new SearchParameters();
    customerAddressSearchParameter.paging = this.paging;
    customerAddressSearchParameter.sorting = this.sort;
    customerAddressSearchParameter.customerId = this.customerId;

    this.competitorAddressRequest.searchParameters = customerAddressSearchParameter;
    this.competitorAddressRequest.searchParameters.searchText = '';



    this.client.getCustomerAddressHeaders(this.competitorAddressRequest).subscribe(res => {

      if (res != null && res.lines.length > 0) {

        res.lines.forEach(item => {
          this.customerAddress.push(item.address);
        });

        // this.addressDropdown = true;
        // res.lines.forEach(data => {
        //   let competitorModel: any =
        //   {
        //     id: data.address.addressId,
        //     contactName: data.contactName,
        //     addressCode: data.address.addressCode,
        //     address: this.getAddressData(data.address),

        //   }
        //   this.competitorModles.push(competitorModel);
        // })
        this.addressDropdown = true;
        this.epbtFaCompetitorService.competitorPricing.competitorAddress = res.lines;
        if (this.epbtFaCompetitorService.competitorPricing.SelectedAddress) {
          this.selectedAddressId = this.epbtFaCompetitorService.competitorPricing.SelectedAddressIndex;
        } else {
          this.epbtFaCompetitorService.competitorPricing.SelectedAddress = res.lines[0].address;
          this.epbtFaCompetitorService.competitorPricing.SelectedAddressIndex = res.lines[0].address.addressId;
          this.selectedAddressId = res.lines[0].address.addressId;
        }
      }
    });

  }

  // address field mapping start
  getAddressData(addressObj: any) {
    const address = [addressObj.address1, addressObj.address2,
    addressObj.address3, addressObj.city,
    addressObj.county, addressObj.postCode, addressObj.country].filter(Boolean).join(', ');
    return address;
  }



  onValueChange(selectedValue: any): void {
    this.epbtFaCompetitorService.selectCompetitorTypeId = selectedValue;
    if (selectedValue == 1) {
      this.addressCodeDropdown = true;
    } else {
      this.addressCodeDropdown = false;
    }
    this.epbtFaCompetitorService.competitorPricing.PriceType = selectedValue;
  }

  onAddresscodeChange(selectedValue: any): void {
    if (selectedValue) {
      this.epbtFaCompetitorService.selectCompetitorAddress = selectedValue;
      this.epbtFaCompetitorService.selectCompetitorAddressId = this.epbtFaCompetitorService.selectCompetitorAddress.addressId;
      this.epbtFaCompetitorService.competitorPricing.SelectedAddress = selectedValue; // this.competitorModles.find(item => item.id == this.epbtFaCompetitorService.selectCompetitorAddress);
      this.epbtFaCompetitorService.competitorPricing.SelectedAddressIndex = selectedValue.addressId;
      this.selectedAddressId = selectedValue.addressId;
      // this.epbtFaCompetitorService.competitorPricing.
    }
  }

  onSubmit() {
    this.epbtFaCompetitorService.customerId = this.customerId;
    this.epbtFaCompetitorService.searchCompetitorString = this.competitorPricingForm.controls['competitor'].value;
    if (!this.epbtFaCompetitorService.searchCompetitorString || !this.epbtFaCompetitorService.competitorPricing.customer) {
      this.errorCustomer = 'Please select a competitor';
      this.epbtFaCompetitorService.competitorPriceFormFlag = false;
    } else if (this.epbtFaCompetitorService.searchCompetitorString != this.epbtFaCompetitorService.competitorPricing.customer.name) {
      this.errorCustomer = 'Please select a competitor';
      this.epbtFaCompetitorService.competitorPriceFormFlag = false;
    } else {
      this.errorCustomer = '';
      this.epbtFaCompetitorService.competitorPriceFormFlag = true;
    }
  }
}
